import { colors, combineStyles, fonts, media, mixins } from 'consumer-components';
import { OpenCSSProperties } from 'aphrodite';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import PaneLayoutConstants from 'login-constants/paneLayoutConstants';

export const buttonSelected = {
  ...mixins.border(2, 'solid', deploymentConfig.getOrganizationColors().action),
};

export const buttonText = {
  color: colors.darkerGray,
  fontWeight: fonts.weight.bold,
  fontSize: 18,
  [media.mobileMedium]: {
    fontSize: 16,
  },
};

export const buttonSubText = {
  color: colors.clayPlus3,
  fontSize: 14,
  fontWeight: fonts.weight.book,
  lineHeight: 1.4,
  paddingTop: 5,
};

export const textWrapper = {
  ...fonts.Roboto,
  textAlign: 'left',
} as OpenCSSProperties;

export const button = combineStyles(
  PaneLayoutConstants.splitContentStaticWidthMixin,
  mixins.border(2, 'solid', colors.white),
  mixins.borderRadius(10),
  {
    alignItems: 'center',
    backgroundColor: colors.white,
    boxShadow: mixins.boxShadow(0, 0, 6, 0, mixins.rgba(0, 0, 0, 0.24)),
    display: 'flex',
    marginBottom: 20,
    ':hover': combineStyles(mixins.border(2, 'solid', deploymentConfig.getOrganizationColors().action), {
      cursor: 'pointer',
    }),
    [media.mobileMedium]: {
      marginBottom: 12,
      paddingRight: 12,
    },
    ':last-of-type': {
      marginBottom: 0,
    },
  },
);
